import React, { useCallback, useRef } from 'react';
import { useAssistanceFieldContext } from '../../document/pages/Assistance/AssistanceFieldContext.tsx';
import useForceSelectionLookupProps, {
    useForceSelectionReselectEventListener,
} from '../../document/components/useForceSelectionLookupProps';
import AutoCompleteField from '../../core/components/Fields/AutoCompleteField';
import { useFieldProps } from '../../document/pages/Assistance/customizable/Field';
import { renderArticleIdOption } from '../../document/components/useLookup';

/**
 * Wrapper for ArticleNumberField that uses force-selection lookup
 * for Siemens List of Services article fields.
 */
export const SiemensArticleNumberFieldWrapper = React.memo((props: any) => {
    const assistanceFieldContext = useAssistanceFieldContext();
    const { lookupFieldName, lookupDefinitionId, partitionId: configPartitionId } = assistanceFieldContext.config;

    const fieldProps = useFieldProps(props);

    const originalOnUpdatePayloadChange = useRef(props.onUpdatePayloadChange);
    originalOnUpdatePayloadChange.current = props.onUpdatePayloadChange;

    const wrappedOnUpdatePayloadChange = useCallback((payload: any) => {
        originalOnUpdatePayloadChange.current?.(payload);
    }, []);

    const forceSelectionLookupProps = useForceSelectionLookupProps({
        ...assistanceFieldContext.config,
        lookupType: assistanceFieldContext.config.lookupType,
        lookupDefinitionId,
        lookupFieldName,
        partitionId: configPartitionId,
        allowInvalidIds: false,
        value: props.value,
        onValueChange: props.onChange,
        onUpdatePayloadChange: wrappedOnUpdatePayloadChange,
        onFocus: fieldProps.onFocus,
        onBlur: fieldProps.onBlur,
        onCommit: fieldProps.onCommit,
        lookupMatchingProps: {
            ...assistanceFieldContext.config.lookupMatchingProps,
            searchLookupOnEmptyValue: true,
        },
    });

    useForceSelectionReselectEventListener(props.inputRef, forceSelectionLookupProps.onValueChange);

    return (
        <AutoCompleteField
            {...fieldProps}
            {...forceSelectionLookupProps}
            renderOption={renderArticleIdOption(lookupFieldName)}
        />
    );
});
